<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'cross-analysis-1';
const attrs = `border='1' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
.cross-analysis-1 {
  thead {
    background-color: var(--theme-color-1);
    height: 60px;
    th {
      color: #fff;
      padding: 4px 6px;
      font-weight: 600;
      font-size: 16px;
    }
  }
  tbody {
    tr {
      height: 60px;
      break-inside: avoid;
      td {
        font-size: 16px;
        font-weight: 600;
        color: #3e3e3e;
        padding: 4px 6px;
      }
    }
  }
}
</style>
